export const apis = {
  getPayGameList: '/api/pcpay/payCenterList',
  getPayPrice: '/api/pcpay/priceList',
  getServerList: '/api/pcpay/serverList',
  getRoleInfo: '/api/pcpay/roleInfo',
  submitPay: '/api/pcpay/pay',
  banners: '/api/pcpay/banner',
  orderInfo: '/api/pcpay/getOrderInfo',
  getTab: '/api/pcpay/priceTab',
  valDiscountCode: '/api/pcpay/checkDiscountCode',
  custUrl: '/api/pcpay/customerConfig',
  report: '/api/pcpay/report',
  gameList: '/api/pcpay/getPcszGameList',
  serverList: '/api/pcpay/getPcszServerList',
  roleList: '/api/pcpay/getPczsRoleList',
  lastLoginRole: '/api/pcpay/getPcszLastLoginRole',
  getWebPayConfig: '/api/pcpay/getWebPayConfig',
  getCashierConfig: '/api/pcpay/getCashierConfig',
}
export function getUrlParamByData(data) {
  let uriParams = '';
  for(var i in data) {
      uriParams += uriParams ? '&' : '?';
      let param = `${i}=${encodeURIComponent(data[i])}`;
      uriParams += param;
  }
  return uriParams;
}
